export enum TaskFilterStatusEnum {
  Starting = "Начальный",
  Pause = "На паузе",
  Work = "В работе",
  Success = "Успешно",
  Cancelled = "Отменено",
  NoStatus = "Не задан",
}
